// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/laravel-mix/node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/laravel-mix/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "._2wWDgl-y2DQUoJDnF5MyQw\\=\\={-moz-column-count:1;column-count:1;list-style:none}.ycPVVHN2CMnpnVZ6NNWGPg\\=\\={line-height:2rem}", "",{"version":3,"sources":["webpack://./resources/js/components/FormComponents/BlCheckboxGroup/styles.module.scss"],"names":[],"mappings":"AAAA,6BACI,mBAAA,CAAA,cAAA,CACA,eACJ,CAEA,4BACI,gBACJ","sourcesContent":[".checkbox_group {\n    column-count: 1;\n    list-style: none;\n}\n\n.checkbox {\n    line-height: 2rem;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"checkbox_group": "_2wWDgl-y2DQUoJDnF5MyQw==",
	"checkbox": "ycPVVHN2CMnpnVZ6NNWGPg=="
};
export default ___CSS_LOADER_EXPORT___;
